import { HUE_STOPS, type Hue } from "@/lib/identity";

/** One set of gradients for the whole app. Icons reference them as url(#zh-gr-<hue>). */
export function GradientDefs() {
  return (
    <svg width="0" height="0" aria-hidden="true" style={{ position: "absolute" }}>
      <defs>
        {(Object.keys(HUE_STOPS) as Hue[]).map((hue) => (
          <linearGradient key={hue} id={`zh-gr-${hue}`} x1="0" y1="0" x2="1" y2="1">
            <stop offset="0" stopColor={HUE_STOPS[hue][0]} />
            <stop offset="1" stopColor={HUE_STOPS[hue][1]} />
          </linearGradient>
        ))}
        <linearGradient id="zh-spark" x1="0" y1="0" x2="1" y2="1">
          <stop offset="0" stopColor="#4DA3FF" />
          <stop offset="0.55" stopColor="#6B3BFF" />
          <stop offset="1" stopColor="#9B7BFF" />
        </linearGradient>
        <linearGradient
          id="zh-logo-g"
          gradientUnits="userSpaceOnUse"
          x1="10"
          y1="11"
          x2="38"
          y2="39"
        >
          <stop offset="0" stopColor="#FFFFFF" />
          <stop offset="1" stopColor="#EEF1FF" />
        </linearGradient>
      </defs>
    </svg>
  );
}
